<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-card
          :elevation="hover ? 12 : 2"
          class="mx-auto"
          max-width="380"
          @click="openInfo"
      >
        <div class="card-weather-class" :class="[weather.cCode,weather.isDay ?  '' : 'night']">
          <div class="layer layer1" style="transform: translate3d(0px, 0px, 0px);"></div>
          <div class="layer layer2" style="transform: translate3d(0px, 0px, 0px);"></div>
          <div class="layer layer3" style="transform: translate3d(0px, 0px, 0px);"></div>
          <div class="pa-1">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="text-h5" :class="weather.isDay ?  '' : 'white--text'">
                  {{ weather.city }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <div :class="weather.isDay ? '' : 'white--text'">
                    {{ weather.updateTime }}
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content v-if="weather.alarm instanceof Array && weather.alarm.length !== 0"
                                   class="text-right"
                                   :style="{'color' : warningCode[weather.alarm[0].level_code]}">
                <v-list-item-title>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs"
                           v-on="on"
                           class="text-h5">
                        {{ weather.alarm[0].type_name }}
                      </div>
                    </template>
                    <span>{{ weather.alarm[0].detail }}</span>
                  </v-tooltip>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <div :style="{'color' : warningCode[weather.alarm[0].level_code]}">{{
                      weather.alarm[0].level_name
                    }}
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <div class="content-class" :class="weather.isDay ? '' : 'white--text'">
            <v-container>
              <v-row align="center">
                <v-col cols="6">
                  <div class="ml-5 pa-3">
                    <div class="mb-3 text-h2" v-if="weather.tem !== undefined">
                      {{ `${weather.tem}&deg;` }}
                    </div>
                    <div class="mb-3 ml-1" v-if="weather.wea">
                      <span class="text-h4">{{ weather.wea }}</span>
                    </div>
                    <div class="ml-1">
                  <span class="text-h6" v-if="weather.minimumTem !== undefined && weather.highestTem !== undefined">{{
                      `${weather.minimumTem}&deg;C / ${weather.highestTem}&deg;C`
                    }}</span>
                    </div>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="mx-auto pa-3 d-flex justify-center">
                    <v-img
                        max-width="90%" max-height="90%"
                        :src="weather.isDay ? 'day' : 'night'  | jointSvg(weather.weaCode)"
                        width="92"
                    ></v-img>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <div class="content-class mb-10">
            <div class="text-center text-body-1 " :class="weather.isDay ? '' : 'white--text'">
              <div class="my-1" v-if="weather.humidity">
                <span>湿度</span>
                &nbsp;
                <span>{{ `${weather.humidity}%` }}</span>
              </div>
              <div class="my-1" v-if="weather.winDirection">
                <span>{{ weather.winDirection }}</span>
                &nbsp;
                <span>{{ `${weather.win}级` }}</span>
              </div>
              <div class="my-1" v-if="weather.airTips instanceof Array && weather.airTips.length !== 0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                            <span
                                v-bind="attrs"
                                v-on="on"
                                v-html="weather.airTips[0]"
                            ></span>
                  </template>
                  <span v-text="weather.airTips[1]"></span>
                </v-tooltip>
              </div>
            </div>
          </div>
        </div>
      </v-card>

    </v-hover>

    <v-dialog v-model="dialog" v-if="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">

      <v-card>
        <v-toolbar dense flat>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                icon
                @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div class="pa-3">
          <!--逐小时预报-->
          <v-card class="mx-auto">
            <v-card-title>
              <div class="text-h5">
                逐小时预报
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="overflow-x-auto">
              <div class="ct-hours ma-3 ml-8">
                <ol class="ls-weather-hour">
                  <li v-for="(item,index) in weather.forecast_1h" class="item" :key="index">
                    <template v-if="item">
                      <p class="txt-time">{{ $moment(item.update_time, 'YYYYMMDDHHmmss').format('HH:mm') }}</p>
                      <img :src="item.type | jointSvg(item.weather_code)" class="icon" alt="">
                      <p class="txt-degree">{{ item.degree }}&deg;</p>
                    </template>
                  </li>
                </ol>
              </div>
            </v-card-text>
          </v-card>
          <!--7日天气预报-->
          <v-container>
            <v-row class="mt-3">
              <v-col lg="6" xl="6" cols="12">
                <v-card max-width="750" max-height="515" class="mx-auto">
                  <v-card-title>
                    <div class="text-h5">
                      7日天气预报
                    </div>
                  </v-card-title>
                  <v-divider></v-divider>
                  <section class="sec-days">
                    <div class="ct-scroll">
                      <ol class="ls-days">
                        <li class="item" v-for="(item,index) in future.forecast" :key="index"
                            :style="{width: `${500 / future.forecast.length}px`}">
                          <p class="date">{{ weekList[$moment(item.time, 'YYYY-MM-DD').weekday()] }}</p>
                          <p class="date" v-if="index === 0">昨天</p>
                          <p class="date" v-else-if="index === 1">今天</p>
                          <p class="date" v-else-if="index === 2">明天</p>
                          <p class="date" v-else>{{ $moment(item.time, 'YYYY-MM-DD').format('MM-DD') }}</p>
                          <div class="ct-daytime">
                            <p class="weather">{{ item.day_weather }}</p>
                            <img
                                :src="'day' | jointSvg(item.day_weather_code)"
                                class="icon" alt=""/>
                          </div>
                          <div class="ct-night">
                            <img
                                :src="'night' | jointSvg(item.night_weather_code)"
                                class="icon" alt=""/>
                            <p class="weather">{{ item.night_weather_short }}</p>
                          </div>
                          <p class="wind">{{ item.night_wind_direction }}</p>
                          <p class="wind">{{ item.night_wind_power }}级</p></li>
                      </ol>
                    </div>
                    <div class="ct-chart-days">
                      <div v-if="dialog" class="echarts-class" ref="echarts"></div>
                    </div>
                  </section>
                </v-card>
              </v-col>

              <v-col lg="6" xl="6" cols="12">
                <v-card height="515" max-width="750" class="mx-auto">
                  <v-card-title>
                    <div class="text-h5">
                      {{ this.future.sunsetInfo._riseHour.sunrise }}日出 | {{
                        this.future.sunsetInfo._riseHour.sunset
                      }}日落
                    </div>
                  </v-card-title>
                  <v-divider></v-divider>
                  <div v-if="dialog" class="sunset-echarts-class" ref="sunsetEcharts">

                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {getRealTimeWeather} from "@/api/jsonp/weather";
import {mapGetters} from "vuex";
import {getCityInfo} from "@/api/jsonp/city";

export default {
  name: "weather",
  data: () => ({
    weekList: ['周天', '周一', '周二', '周三', '周四', '周五', '周六'],
    dialog: false,
    future: {},
    weatherCharts: null,
    sunsetCharts: null,
    weather: {},
    pCode: {
      "00": "C2",
      "01": "C9",
      "02": "C1",
      "03": "C3",
      "04": "C3",
      "05": "C3",
      "06": "C3",
      "07": "C3",
      "08": "C3",
      "09": "C3",
      10: "C3",
      11: "C3",
      12: "C3",
      13: "C4",
      14: "C4",
      15: "C4",
      16: "C4",
      17: "C4",
      18: "C5",
      19: "C3",
      20: "C7",
      21: "C3",
      22: "C3",
      23: "C3",
      24: "C3",
      25: "C3",
      26: "C4",
      27: "C4",
      28: "C4",
      29: "C7",
      30: "C7",
      31: "C7",
      53: "C6",
      99: "C8",
      32: "C5",
      49: "C5",
      54: "C6",
      55: "C6",
      56: "C6",
      57: "C5",
      58: "C5",
      301: "C3",
      302: "C4"
    },
    nCode: {
      0: "微风",
      1: "东北风",
      2: "东风",
      3: "东南风",
      4: "南风",
      5: "西南风",
      6: "西风",
      7: "西北风",
      8: "北风",
      9: "旋转风"
    },
    warningCode: {
      '01': '#7da0ec',
      '02': '#f5d271',
      '03': '#ef8c6b',
      '04': '#ec807c'
    },
    result: {},
  }),
  computed: {
    ...mapGetters(['getDarker']),
  },
  mounted() {
    this.initWeather();

    window.addEventListener('resize', this.onResize, {passive: true})

    window.callBack = (data) => {
      this.getWeather(data.result.ad_info)
    }
  },
  methods: {
    initWeather() {
      getCityInfo().then(res => {
        console.log(res)
      }).catch(() => {
      })
    },
    getWeather({province, city, county}) {
      let param = {
        source: 'xw',
        refer: 'h5',
        weather_type: 'observe|alarm|air|tips|forecast_24h|forecast_1h|rise',
        province: province,
        city: city,
        county: county ? county : ''
      }

      getRealTimeWeather(param).then(res => {
        let {tips, air, alarm, forecast_24h, observe, forecast_1h, rise} = res.data.data

        //当天
        let {update_time, weather_code, weather, degree, wind_power, wind_direction, humidity} = observe

        let _time = this.$moment(update_time, "YYYYMMDDHHmmss");

        //每天日出日落
        let _rise = Object.keys(rise).map(key => rise[key])

        _rise.forEach(item => {
          item.riseTime = this.$moment(item.time + item.sunrise, "YYYYMMDDHH:mm")
          item.setTime = this.$moment(item.time + item.sunset, "YYYYMMDDHH:mm")
        })

        this._sunset(_time, _rise)

        //逐小时
        let _forecast_1h = Object.keys(forecast_1h).map(key => forecast_1h[key])

        _forecast_1h.forEach(item => {
          let _hour = this.$moment(item.update_time, 'YYYYMMDDHHmmss')
          item.type = this.findToday(_hour, _rise)
        })

        //天气图标
        let _c = this.pCode[weather_code]

        air.aqi && air.aqi.aqi > 200 && "C7" !== _c && (_c = "C6")

        let forecast = Object.keys(forecast_24h).map(key => forecast_24h[key])

        this.weather = {
          updateTime: _time.format('HH:mm'),
          city: county ? county : city,
          weaCode: weather_code,
          wea: weather,
          minimumTem: forecast[1].min_degree,
          highestTem: forecast[1].max_degree,
          airTips: [...Object.keys(tips.observe).map(key => tips.observe[key])],
          win: wind_power,
          humidity,
          winDirection: this.nCode[wind_direction],
          tem: degree,
          alarm: [...Object.keys(alarm).map(key => alarm[key])],
          isDay: this.findToday(_time, _rise) === "day",
          cCode: _c,
          forecast_1h: _forecast_1h
        };

        //echarts
        this.future = {
          forecast: [...forecast],
          maxDegree: [...forecast.map(item => item.max_degree)],
          minDegree: [...forecast.map(item => item.min_degree)],
          timeList: [...forecast.map(item => item.time)],
          sunsetInfo: this._sunset(_time, _rise)
        }
      });
    },
    weatherEcharts({minDegree, maxDegree, timeList}) {
      let option = {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        grid: {
          show: false,
          left: 0,
          right: 0,
          bottom: '20%',
          top: '15%'
        },
        xAxis: {
          show: false,
          type: 'category',
          data: timeList,
        },
        yAxis: {
          show: false,
          type: 'value',
          axisLine: {
            onZero: false,
          },
          minInterval: Math.min(...minDegree),
          maxInterval: Math.max(...maxDegree),
        },
        series: [
          {
            data: maxDegree,
            type: 'line',
            itemStyle: {
              color: 'rgb(255, 213, 79)',
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                fontSize: 16
              },
              formatter: '{c0}°'
            },
            smooth: true
          },
          {
            data: minDegree,
            type: 'line',
            itemStyle: {
              color: 'rgb(38, 170, 253)',
            },
            label: {
              show: true,
              position: 'bottom',
              textStyle: {
                fontSize: 16
              },
              formatter: '{c0}°'
            },
            smooth: true
          }
        ]
      }
      this.$nextTick(() => {
        this.weatherCharts = this.$echarts.init(this.$refs.echarts, 'vintage', {renderer: 'svg'});
        this.weatherCharts.setOption(option);
        this.weatherCharts.resize();
      })
    },
    openInfo() {
      this.dialog = true
      this.$nextTick(() => {
        this.weatherEcharts(this.future)
        this._sunsetEcharts(this.future.sunsetInfo);
      })
    },
    findToday(day, rise) {
      let _riseHour = rise.find(r => this.$moment(r.time, 'YYYYMMDD').month() === day.month() && this.$moment(r.time, 'YYYYMMDD').date() === day.date())
      if (!_riseHour) return
      return day.isAfter(_riseHour.riseTime) && day.isBefore(_riseHour.setTime) ? "day" : "night"
    },
    _sunset(day, rise) {
      let _riseHour = rise.find(r => this.$moment(r.time, 'YYYYMMDD').month() === day.month() && this.$moment(r.time, 'YYYYMMDD').date() === day.date())

      if (!_riseHour) return

      let {sunrise, sunset} = _riseHour

      let sunriseArr = sunrise.split(":")

      let sunsetArr = sunset.split(":")

      sunrise = (sunriseArr[0] * 60) + (sunriseArr[1] * 1)

      sunset = (sunsetArr[0] * 60) + (sunsetArr[1] * 1)

      let current = (this.$moment().get('hour') * 60) + this.$moment().get('minute')

      let max = sunset - sunrise;

      let value = current - sunrise;

      let minute = max % 60

      let hour = (max - minute) / 60

      return {max, hour, minute, value, _riseHour}

    },
    _sunsetEcharts({max, hour, minute, value}) {
      let option = {
        series: [
          {
            startAngle: 180,
            endAngle: 0,
            type: 'gauge',
            progress: {
              show: true,
              width: 18,
              itemStyle: {
                color: '#fec808'
              }
            },
            max: max,
            min: 0,
            axisLine: {
              lineStyle: {
                width: 18
              }
            },
            axisTick: {
              show: false
            },
            pointer: false,
            splitLine: false,
            axisLabel: false,
            anchor: false,
            title: {
              show: true,
            },
            detail: {
              valueAnimation: true,
              fontSize: 39,
              offsetCenter: [0, '70%'],
              formatter: `${hour} 小时 ${minute} 分钟`
            },
            data: [
              {
                value: value,
                name: 'Sunlight',
              }
            ]
          }
        ]
      };

      this.$nextTick(() => {
        this.sunsetCharts = this.$echarts.init(this.$refs.sunsetEcharts, 'vintage', {renderer: 'svg'});
        this.sunsetCharts.setOption(option);
        this.sunsetCharts.resize();
      })
    },
    onResize() {
      this.$nextTick(() => {
        if (this.sunsetCharts) {
          this.sunsetCharts.resize();
        }
      })
    },
  },
  beforeDestroy() {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize)
  },

}
</script>

<style scoped>
@import "weather.css";

.content-class {
  position: relative;
  z-index: 5;
}

.echarts-class {
  height: 100%;
  width: 740px;
  padding: 10px;
}

.sunset-echarts-class {
  height: 350px;
  width: 100%;
}

ol, ul {
  list-style: none;
  padding-left: 0
}
</style>
